<topo-modal
  id="register-phone-modal"
  [isActive]="true"
  [isCard]="true"
  [rawWidth]="!isDesktop && '90%'"
  [rawHeight]="!isDesktop && 'auto'"
  [showLoadingOverlay]="isLoading()">
  <div class="modal-header">
    <div
      class="mx-4 my-4"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <div>
        <h5>{{ 'NOTIFICATION-PREFERENCES.REGISTER-PHONE-NUMBER' | translate }}</h5>
      </div>
      <div>
        <div
          class="dialog-close"
          (click)="cancelPhone()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      @if (!(enterCode$ | async)) {
        <div
          [ngStyle]="{ 'display': !(showEnterCode$ | async) ? 'block' : 'none' }"
          fxLayout="column"
          fxLayoutAlign="space-between center"
          style="width: 100%">
          <div
            fxLayout="column"
            fxLayoutAlign="space-between center"
            style="width: 100%">
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <img
                class="light-topo"
                src="/assets/images/topoone-by-crisis24.svg" />
              <img
                class="dark-topo"
                src="/assets/images/topoone-by-crisis24-white.svg" />
            </div>
            <div class="mt-5 action-label">{{ 'NOTIFICATION-PREFERENCES.REGISTER-PHONE-NUMBER-DESC' | translate }}</div>
            <div>
              <ul>
                <li>{{ 'NOTIFICATION-PREFERENCES.SMS-FEES' | translate }}</li>
                <li>{{ 'NOTIFICATION-PREFERENCES.SMS-FREQUENCY-ALERTS' | translate }}</li>
                <li>{{ 'NOTIFICATION-PREFERENCES.SMS-HELP' | translate }}</li>
                <li>{{ 'NOTIFICATION-PREFERENCES.SMS-OPT-OUT' | translate }}</li>
                <li>
                  <a
                    href="https://files.topo.ai/Crisis24_Mobile_Terms_Of_Service.pdf"
                    target="_blank">
                    {{ 'NOTIFICATION-PREFERENCES.SMS-MOBILE-TERMS-OF-SERVICE' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    href="https://crisis24.garda.com/privacy-policy"
                    target="_blank">
                    {{ 'NOTIFICATION-PREFERENCES.SMS-PRIVACY-POLICY' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            fxLayout="row"
            style="width: 100%"
            class="mb-3">
            <div>
              <label class="opt-in-label">
                <input
                  type="checkbox"
                  formControlName="optInAlerts"
                  class="mr-3" />
                {{ 'NOTIFICATION-PREFERENCES.SMS-OPT-IN-ALERT-NOTIFICATIONS' | translate }}
              </label>
            </div>
          </div>
          <div
            class="mt-2"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            style="width: 100%">
            <topo-phone-input
              formControlName="phone"
              [showErrorState]="!!error()"
              hideErrorMessage
              (blur)="handleBlur()"
              dropdownContainerId="register-phone-modal__portal-outlet" />
          </div>
          @if (!!error()) {
            <topo-notification-banner
              type="error"
              class="mt-5"
              style="width: 100%">
              {{ error() | translate }}
            </topo-notification-banner>
          }
          <topo-app-disclaimer
            class="mt-5"
            style="width: 100%" />
          <button
            class="button is-fullwidth is-primary is-small mt-5"
            (click)="requestCodeClick()"
            [disabled]="!form.value.optInAlerts || phoneControl.invalid">
            {{ 'NOTIFICATION-PREFERENCES.BUTTON-REGISTER-PHONE' | translate }}
          </button>
        </div>
      }

      @if (enterCode$ | async) {
        <div
          [ngStyle]="{ 'display': !(showEnterCode$ | async) ? 'block' : 'none' }"
          fxLayout="column"
          fxLayoutAlign="space-between center"
          style="width: 100%">
          <div
            fxLayout="column"
            fxLayoutAlign="space-between center"
            style="width: 100%">
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <img
                class="light-topo"
                src="/assets/images/topoone-by-crisis24.svg" />
              <img
                class="dark-topo"
                src="/assets/images/topoone-by-crisis24-white.svg" />
            </div>
            <div class="mt-5">{{ 'NOTIFICATION-PREFERENCES.REGISTER-PHONE-NUMBER-DESC-2' | translate }}</div>
          </div>
          <div
            fxLayout="column"
            fxLayoutAlign="space-around center"
            style="width: 100%">
            <input
              class="input mt-5 mb-1"
              [class.is-error]="!!error()"
              type="text"
              placeholder="{{ 'NOTIFICATION-PREFERENCES.ENTER-CODE' | translate }}"
              formControlName="code"
              style="width: 100%" />
            @if (!!error()) {
              <topo-notification-banner
                type="error"
                class="mt-5"
                style="width: 100%">
                {{ error() | translate }}
              </topo-notification-banner>
            }
            <topo-app-disclaimer class="my-5" />
            <button
              [disabled]="!form.value.code"
              class="button is-fullwidth is-primary is-small mt-5"
              style="width: 100%"
              (click)="verifyCode()">
              {{ 'NOTIFICATION-PREFERENCES.BUTTON-VERIFY-CODE' | translate }}
            </button>
          </div>
        </div>
      }
    </form>
  </div>

  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end">
      <button
        class="button is-secondary is-small"
        style="min-width: 75px"
        (click)="cancelPhone()">
        {{ 'NOTIFICATION-PREFERENCES.BUTTON-CANCEL' | translate }}
      </button>
    </div>
  </div>
</topo-modal>
